<template>
    <div class="site-header">
        <div class="branding row">
            <a class="hamburger hide-for-medium" @click.prevent="showMobileMenu = !showMobileMenu" href="#"></a>
            <router-link to="/" class="logo-link"><img src="../../images/fizmix-teacher-logo.svg" alt="Fizmix skolotājiem logo" class="logo" style="width: 344.812px; height: 32px;"/></router-link>
            <app-search v-if="isAuthenticated"></app-search>
        </div>
        <div class="top-bar-container">
            <div class="top-bar row show-for-medium">
                <div class="top-bar-left">
                    <ul class="dropdown menu megamenu" data-dropdown-menu>
                        <li><router-link to="/" class="home-link"><svg-icon :symbol="homeIcon.default" :originalDims="true"></svg-icon></router-link></li>
                        <li v-for="category in categories" class="is-dropdown-submenu-parent">
                            <router-link :to="{ name: 'category', params: { categoryNodeId: category.id }}">{{ category.category.title }}</router-link>
                            <ul class="menu is-dropdown-submenu" v-if="category.children.length > 0">
                                <li v-for="theme in category.children">
                                    <router-link :to="{ name: 'category', params: { categoryNodeId: theme.id }}">
                                        <img class="icon-inline icon-large" :src="theme.category.icon_url"/><span> {{ theme.category.title }}</span>
                                    </router-link>
                                </li>
                            </ul>
                        </li>
                        <li><router-link :to="{ name: 'posts' }">Jaunumi</router-link></li>
                    </ul>
                </div>
                <div class="top-bar-right">
                    <ul class="dropdown menu show-for-medium" data-dropdown-menu>
                        <li v-if="isAuthenticated && inboxStats && inboxStats.newMessagesCount > 0" class="inbox-notification">
                            <router-link :to="{ name: 'inbox.messages' }"><svg-icon :symbol="messageIcon.default" class="icon-inline"></svg-icon><span class="badge">{{ inboxStats.newMessagesCount }}</span></router-link>
                        </li>
                        <li v-if="isAuthenticated && inboxStats && inboxStats.newCommentsCount > 0" class="inbox-notification">
                            <router-link :to="{ name: 'inbox.comments' }"><svg-icon :symbol="commentIcon.default" class="icon-inline"></svg-icon><span class="badge">{{ inboxStats.newCommentsCount }}</span></router-link>
                        </li>

                        <li v-if="isAuthenticated" key="user-menu">
                            <router-link v-if="user" :to="{ name: 'profile' }" class="avatar"><avatar :avatar="user.avatar" class="icon-avatar"></avatar><span>{{ user.name }}</span></router-link>
                            <ul class="menu is-dropdown-submenu">
                                <li><router-link :to="{ name: 'inbox.comments' }">Komentāri</router-link></li>
                                <li><router-link :to="{ name: 'inbox.messages' }">Ziņas</router-link></li>
                                <li><a href="#" @click="logout()">Izrakstīties</a></li>
                            </ul>
                        </li>
                        <template v-else>
                            <li>
                                <a href="#" v-open-in-reveal="loginReveal">
                                    <svg-icon :symbol="lockIcon.default" class="icon-inline"></svg-icon>
                                    <span>Autorizējies</span>
                                </a>
                            </li>
                            <li><a href="#" v-open-in-reveal="registerReveal"><span>Reģistrējies</span></a></li>
                        </template>
                    </ul>
                </div>
            </div>
        </div>

        <div class="drawer hide-for-medium" :class="{ show: showMobileMenu }">
            <button class="close-button" @click.prevent="showMobileMenu = false" type="button">&times;</button>

            <ul class="vertical menu">
                <li v-if="!isAuthenticated" key="login" style="padding:1em;"><a href="#" v-open-in-reveal="loginReveal" class="button hollow white"><svg-icon :symbol="lockIcon.default" class="icon-inline"></svg-icon><span>Autorizējies</span></a></li>

                <li v-if="isAuthenticated">
                    <router-link v-if="user" :to="{ name: 'profile' }"><avatar :avatar="user.avatar" class="user-avatar"></avatar><span class="user-name">{{ user.name }}</span></router-link>
                </li>

                <li v-if="isAuthenticated">
                    <a href="#" @click="logout()">Izrakstīties</a>
                </li>
            </ul>

            <ul class="vertical drilldown menu" data-drilldown-menu>
                <li><router-link to="/" class="home-link"><svg-icon :symbol="homeIcon.default" :originalDims="true"></svg-icon></router-link></li>
                <li><router-link :to="{ name: 'posts' }">Jaunumi</router-link></li>
                <li v-for="category in categories" class="">
                    <a href="#" @click.native="canNavigate($event)">{{ category.category.title }}</a>
                    <ul class="menu" v-if="category.children.length > 0">
                        <li v-for="theme in category.children">
                            <a href="" @click.prevent="canNavigate($event, theme.id)">
                                <img class="icon-inline icon-large" :src="theme.category.icon_url"/><span> {{ theme.category.title }}</span>
                            </a>
                        </li>
                    </ul>
                </li>

            </ul>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import Foundation from 'foundation-sites/dist/js/npm'
    import SvgIcon from './SvgIcon'
    import Avatar from './Avatar'
    import AppSearch from '../components/Search'
    import OpenInReveal from '../directives/OpenInReveal'
    import LoginReveal from './auth/LoginReveal'
    import RegisterReveal from './auth/RegisterReveal'
    import { mapGetters } from 'vuex'

    let responsiveMenu = [];

    export default {

        created() {
            console.log('topbar created');
            if (this.categories.length === 0) {
                this.$store.dispatch('getCategories');
            }

            if (this.isAuthenticated && this.user) {
                this.$store.dispatch('getInboxStats')
            }

        },

        mounted() {
            //const menuElement = $(this.$el).find('[data-responsive-menu]');
            const dropDownMenuElements = $(this.$el).find('[data-dropdown-menu]');
            const drillDownMenuElements = $(this.$el).find('[data-drilldown-menu]');

            this.getCategories().then(response =>  {
                setTimeout(() => {
                    //responsiveMenu.push(new Foundation.ResponsiveMenu(menuElement));
                    responsiveMenu.push(new Foundation.DropdownMenu(dropDownMenuElements))
                    responsiveMenu.push(new Foundation.Drilldown(drillDownMenuElements, {
                        'backButton': '<li class="js-drilldown-back"><a tabindex="0">Atpakaļ</a></li>',
                        'closeOnClick': true,
                        'dataAutoHeight': true
                    }))
                }, 2)
            })
        },

        destroyed() {
            console.log('topbar destroyed')
            responsiveMenu.forEach(function (el) {
                if (el.foundation) {
                    el.foundation.destroy();

                }
            });
            responsiveMenu = [];
        },

        data() {
            return {
                lockIcon: require('../../icons/icon-lock.svg-sprite'),
                homeIcon: require('../../icons/icon-home.svg-sprite'),
                commentIcon: require('../../icons/icon-comment.svg-sprite'),
                messageIcon: require('../../icons/icon-message.svg-sprite'),
                loginReveal: LoginReveal,
                registerReveal: RegisterReveal,
                showMobileMenu: false,
            }
        },

        methods: {
            /**
             * Log out
             */
            logout() {
                this.$store.dispatch('logout')
                    .then(() => this.$router.push('/'))
            },

            /**
             * Get categories or request if not loaded and return promise
             * @returns {Promise<any>}
             */
            async getCategories() {
                return this.categories.length > 0 ? this.categories : await this.$store.dispatch('getCategories')
            },

            createResponsiveMenu(el) {
                if (el.foundation) {
                    el.foundation.destroy();
                    responsiveMenu.filter()
                }

                responsiveMenu.push(new Foundation.ResponsiveMenu(el));
            },

            canNavigate(event, id) {
                if (event.target.parentNode.classList.contains('is-drilldown-submenu-parent')) {
                    event.preventDefault();
                } else {
                    this.$router.push({ name: 'category', params: { categoryNodeId: id }});
                    this.showMobileMenu = false;
                }
            }
        },

        computed: {
            ...mapGetters(['isAuthenticated', 'user', 'categories', 'inboxStats']),
        },

        watch: {
            'user': function (val, oldVal) {
                if (val) {
                    this.$store.dispatch('getInboxStats')
                }
            },

            'showMobileMenu': function (val, oldVal) {
                if (val === true) {
                    document.querySelector('body').classList.add('is-mobile-menu-expanded');
                } else {
                    document.querySelector('body').classList.remove('is-mobile-menu-expanded');
                }

            }
        },

        components: { SvgIcon, Avatar, AppSearch },

        directives: {
            'open-in-reveal': OpenInReveal
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../sass/settings";
    @import "../../sass/mixins";
    @import "../../sass/foundation/config";

    .site-header {
        background-color: white;
    }

    .branding {
        min-height: 100px;
        padding: 20px 15px;
        align-items: center;
        flex-wrap: nowrap;

        @include breakpoint(small down) {
            flex-wrap: wrap;

            .logo-link {
                flex: 1 1 calc(100% - 40px);
            }

            .search-panel {
                margin-top: 1rem;
                flex: 1 1 100%;

                &.expanded {
                    margin-left: 0;
                }
            }
        }

        .hamburger {
            margin-right: 1rem;
            flex-shrink: 0;
        }
    }

    .hamburger {
        position: relative;
        display: inline-block;
        vertical-align: middle;
        cursor: pointer;
        width: 24px;
        height: 20px;

        &:after {
            content: "";
            position: absolute;
            display: block;
            width: 100%;
            height: 4px;
            background: #007395;
            top: 0;
            left: 0;
            box-shadow: 0 8px 0 #007395, 0 16px 0 #007395;
        }
    }

    .top-bar-container {
        background-color: $topbar-navigation-bg;
    }

    .drawer {
        background-color: $topbar-navigation-bg;
        position: fixed;
        top: 0;
        bottom: 0;
        padding-top: 3em;
        max-width: 250px;
        width: 250px;
        z-index: 1;
        transform: translateX(-100%);
        transition: transform 0.25s ease-in-out;
        overflow-y: auto;

        .close-button {
            z-index: 2;
            color: white;
        }

        a {
            color: white;
        }

        svg.user-avatar {
            width: 84px;
            height: 84px;
            display: block;
        }

        img.user-avatar {
            width: 84px;
            height: auto;
            display: block;
        }


        .user-name {
            display: block;
            margin-top: 0.8rem;
        }

        > .is-drilldown {
            clear: both;
            width: 100%;

            > .menu {
                width: 100%;
            }
        }

        .close-button {
            float: right;
            margin: 0;
        }

        .menu.drilldown {
            color: white;

            a {
                color: inherit;
            }

            .icon-inline {
                width: 2em;
                height: auto;
                margin-right: 1em;
                flex-grow: 0;
                flex-shrink: 0;
            }

            > li > a {

                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-start;
            }
        }

        &.show {
            transform: translateY(0);
        }
    }

    .top-bar {
        $topbar-nav-font-size: 14px;
        $topbar-nav-height: 42px;

        .menu {
            font-size: rem-calc($topbar-nav-font-size);

            a {
                color: $body-color;
            }

            &.submenu {
                img.icon-large {
                    width: px-em(28px);
                    height: auto;
                }

                img.icon-inline {
                    margin-right: 1em;
                }
            }

            &:not(.submenu) {

                > li {

                    &.inbox-notification {

                        svg.icon {
                            fill: white;
                        }

                        > a {
                            padding: 10.5px;

                            .icon.icon-inline {
                                width: 1.5em;
                                height: 1.5em;
                                vertical-align: middle;
                            }
                        }
                    }

                    > a {
                        color: white;
                        font-size: inherit;
                        padding: 1em px-em(16px, 14px);
                        height: px-em($topbar-nav-height, $topbar-nav-font-size);

                        &.avatar {
                            padding: px-em(7.5px, 14px) px-em(16px, 14px);
                        }

                        &.home-link {
                            $home-icon-size: 16px;

                            padding: px-em(($topbar-nav-height - $home-icon-size) / 2, $topbar-nav-font-size);

                            .icon-home {
                                width: px-em($home-icon-size, $topbar-nav-font-size);
                                height: px-em($home-icon-size, $topbar-nav-font-size);
                            }
                        }

                        .icon-inline {
                            width: 1em;
                            height: 1em;
                            vertical-align: middle;

                            &.icon-lock {
                                margin-top: -0.3em;
                            }
                        }

                        .icon-avatar {
                            width: 28px;
                            height: 28px;
                            vertical-align: middle;
                            margin-right: 0.5em;
                        }
                    }
                }

                > li.is-active > a {
                    color: $dropdown-menu-item-color-active;
                    background: $dropdown-menu-item-background-active;
                }
            }
        }
    }

    @include breakpoint(medium) {
        .megamenu {
            .is-dropdown-submenu-parent {
                position: static;//Megamenu
            }

            .first-sub.is-dropdown-submenu {
                flex-flow: column wrap;
                padding: 24px;
                max-height: 200px;
                height: 200px;//Without explicit height Safari doesn't work properly

                &.js-dropdown-active {
                    display: flex;
                }

                > li {
                    width: auto;
                }
            }

            .first-sub {
                right: 0;
                left: 0;
                width: 100%;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/TopBar.vue